import React, { Fragment, useEffect, useState } from "react";
import videoBooth from "../../assets/icons/icons8-360-view-48.png";
import booth from "../../assets/icons/icons8-booth-50.png";
import print from "../../assets/icons/icons8-print-30.png";
import game from "../../assets/icons/icons8-joystick-48.png";
import bgImage from "../../assets/images/blue.jpg";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";

const SERVICES = [
  {
    icon: print,
    title: "Customized Prints",
    desc: "Personalized photo prints designed to match your event theme. From weddings to corporate events, we create premium prints that turn moments into lasting memories.",
  },
  {
    icon: booth,
    title: "Photo Booth",
    desc: "A premium photobooth experience with high-quality photos, instant prints, and digital sharing. A fun and engaging attraction for any event.",
  },
  {
    icon: videoBooth,
    title: "360 Video Booth",
    desc: "Capture every angle with our 360° video booth. Create stunning slow-motion videos your guests can instantly share on social media.",
  },
  {
    icon: game,
    title: "Marketing Games",
    desc: "Interactive marketing games like Spin the Wheel, Memory Card Games, and touch-screen challenges on a 55-inch display. Perfect for boosting engagement, brand awareness, and crowd interaction.",
  },
];

const STATS = [
  { value: 2, label: "Years in Business" },
  { value: 1000, label: "Events" },
];

const Services = () => {
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const handleScroll = () => {
      const section = document.querySelector(".stats");
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight) {
          setStartCount(true);
          window.removeEventListener("scroll", handleScroll);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Fragment>
      <section
        id="service"
        className="w-full min-h-screen flex flex-col items-center justify-start relative overflow-x-hidden bg-gradient-to-t from-black via-transparent to-black px-4 sm:px-10"
      >
        {/* ✅ Background — now uses imported asset so the path is always correct */}
        <img
          src={bgImage}
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
          fetchpriority="low"
          className="absolute inset-0 w-full h-full object-cover opacity-30 -z-10 pointer-events-none"
        />

        {/* Title */}
        <p
          data-aos="fade-down"
          className="uppercase text-[#76cfff] tracking-[4px] mb-12 text-[16px] sm:text-[18px] font-bold text-center font-[Poppins]"
        >
          Our Services Include
        </p>

        {/* SERVICES */}
        <div className="w-full flex justify-center items-stretch flex-wrap gap-[40px]">
          {SERVICES.map((service, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
              className="
                w-full sm:w-[48%] lg:w-[450px]
                flex flex-col gap-4
                p-8 rounded-[32px]
                bg-white/5 backdrop-blur-md
                border border-white/10
                transition-all duration-300
                hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(118,207,255,0.25)]
              "
            >
              {/* ✅ Icons — lazy loaded, fixed size to prevent layout shift */}
              <img
                src={service.icon}
                alt={service.title}
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                width={40}
                height={40}
                className="w-[40px] h-[40px]"
              />
              <h2 className="text-white text-[20px] sm:text-[24px] uppercase font-semibold font-[Poppins]">
                {service.title}
              </h2>
              <p className="text-white text-[14px] leading-relaxed font-light font-[Poppins]">
                {service.desc}
              </p>
            </div>
          ))}
        </div>

        {/* STATS */}
        <div className="stats w-full flex justify-center items-center flex-wrap gap-[30px] mt-16">
          {STATS.map((stat, i) => (
            <div
              key={i}
              data-aos={i === 0 ? "fade-right" : "fade-left"}
              className="
                w-full sm:w-[48%] lg:w-[380px]
                border border-white/20
                rounded-[32px]
                p-8 flex items-center gap-6
                bg-white/5 backdrop-blur-md
              "
            >
              <h2 className="text-white text-[60px] sm:text-[80px] font-bold font-[Poppins] leading-none">
                <span className="text-[#76cfff]">+</span>
                {startCount && (
                  <CountUp start={0} end={stat.value} duration={4} />
                )}
              </h2>
              <p className="text-white text-[14px] font-light font-[Poppins]">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </section>
    </Fragment>
  );
};

export default Services;